import React from "react";
import { Box, Typography, Button, Stack, useTheme, useMediaQuery } from "@mui/material";

const NoDataFound = ({
CustomIcon = null,
  message = "No Data Found",
  subMessage = "We couldn't find any data to display at the moment",
  actionText = "Refresh",
  onAction = () => console.log("Action clicked"),
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const containerVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <Box
      initial="initial"
      animate="animate"
      variants={containerVariants}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        padding: theme.spacing(3),
      }}
    >
      <Stack spacing={3} alignItems="center">
      {CustomIcon&&<CustomIcon 
            size={isMobile ? 120 : 200} 
            color={theme.palette.text.secondary}
            aria-hidden="true"
          />}

        <Typography
          variant={isMobile ? "h6" : "h5"}
          component="h2"
          color="text.primary"
          align="center"
          sx={{
            fontWeight: 600,
            animation: "fadeIn 0.6s ease-in"
          }}
        >
          {message}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          align="center"
          sx={{ maxWidth: "400px" }}
        >
          {subMessage}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={onAction}
          sx={{
            mt: 2,
            minWidth: "150px",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: theme.shadows[4]
            }
          }}
        >
          {actionText}
        </Button>
      </Stack>
    </Box>
  );
};

export default NoDataFound;